<template>
  <div align="center" id="lv_Air_Quality" class="div-detail-aqi p-1">
    <!-- <div class="al-center div-detail-aqi-h">
      <h5 class="text_size" >
        <b>Air Quality index level of health concern</b>
      </h5>
    </div> -->
    <div
      style="display: flex"
      class="al-center mr-1"
      v-for="i in labeltextaqi"
      :key="i"
    >
      <div class="mr-1">
        <img style="width: 30px" :src="i.img" />
      </div>
      <div :class="i.color">
        <a class="text_size" style="font-weight: 800">{{ i.text }}</a>
        <br /><a class="thFontthai text_size">{{ i.th }}</a
        ><br /><a style="font-weight: 600" class="text_size">{{ i.lv }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      labeltextaqi: [
        {
          img: require("@/assets/images/yamahaaqi/lv/lv1.png"),
          text: "Good",
          th: "ดี",
          color: "pTextL2",
          lv: "0 to 50",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv2.png"),
          text: "Moderate",
          th: "ปานกลาง",
          color: "pTextL3",
          lv: "51 to 100",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv3.png"),
          text: "Unhealthy",
          th: "เริ่มมีผลต่อสุขภาพ",
          color: "pTextL4",
          lv: "101 to 150",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv4.png"),
          text: "Literally Unhealthy",
          th: "มีผลต่อสุขภาพมาก",
          color: "pTextL5",
          lv: "151 to 200",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv5.png"),
          text: "Very Unhealthy",
          th: "มีผลต่อสุขภาพมาก",
          color: "pTextL6",
          lv: "201 to 300",
        },
        {
          img: require("@/assets/images/yamahaaqi/lv/lv6.png"),
          text: "Hazardous",
          th: "อันตรายต่อสุขภาพ",
          color: "pTextL7",
          lv: "301 to 500",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./../aqi.scss";
.div-detail-aqi {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  height: 100%;
}

.pTextL1 {
  color: #0cbbc4;
}
.pTextL2 {
  color: #168848;
}
.pTextL3 {
  color: #c4b50c;
}
.pTextL4 {
  color: #bf7c2f;
}
.pTextL5 {
  color: #c41c0c;
}
.pTextL6 {
  color: #9a2fbf;
}
.pTextL7 {
  color: #745726;
}
</style>